//Component Imports
import Header from "../Global/header";
import Footer from "../Global/footer";
import Privacy from "./privacy";

export default function PrivacyPage() {
  return (
    <main>
      <Header />
      <Privacy />
      <Footer />
    </main>
  );
}